import React from "react";
import Header from "../../../Components/Header";
import RejectionListComp from "../../../Components/OMS/RejectionListComp/RejectionListComp";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { OMSSERVICES } from "../../../Configuration/Telecaller_URl";

function RejectionList() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <div className="card-box">
            <RejectionListComp
              URL={OMSSERVICES.REJECTION_CUSTOMER}
              mainType={"HNI"}
            />
          </div>
        </div>
      </main>
    </>
  );
}

export default RejectionList;
